import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            热度榜单
          </h2>
          <div className="mt-4 w-16 h-1 bg-accent-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">实时热度排行，看看大家都在关注什么</p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-3 md:space-y-4">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center font-bold font-heading text-sm md:text-base ${
                item.rank <= 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs text-accent-500 font-medium">{item.heat}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-accent-500 transition-colors duration-200 flex-shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}